import React from 'react';
import { BoxVisualizer } from './BoxVisualizer';
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from './ui/drawer';

export const BoxDrawer = ({ open, onClose, onCheckout }) => {
  return (
    <Drawer open={open} onOpenChange={onClose}>
      <DrawerContent className="bg-background">
        <DrawerHeader className="sr-only">
          <DrawerTitle>Your Sample Box</DrawerTitle>
        </DrawerHeader>
        <div className="px-4 pb-8 max-h-[80vh] overflow-y-auto">
          <BoxVisualizer onCheckout={onCheckout} />
        </div>
      </DrawerContent>
    </Drawer>
  );
};
